var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductMovement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0625 1.375C2.4422 1.375 2.75 1.6828 2.75 2.0625V19.25H19.9375C20.3172 19.25 20.625 19.5578 20.625 19.9375C20.625 20.3172 20.3172 20.625 19.9375 20.625H2.0625C1.6828 20.625 1.375 20.3172 1.375 19.9375V2.0625C1.375 1.6828 1.6828 1.375 2.0625 1.375Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1789 2.16872C21.5344 2.30204 21.7146 2.69832 21.5813 3.05384L18.4875 11.3038C18.3869 11.5722 18.1304 11.7499 17.8438 11.7499H14.4305L11.8846 15.5688C11.7703 15.7402 11.5852 15.8513 11.3803 15.8716C11.1753 15.8919 10.972 15.8192 10.8264 15.6736L8.8493 13.6965L6.23462 15.7301C5.9349 15.9632 5.50296 15.9092 5.26985 15.6095C5.03674 15.3098 5.09073 14.8779 5.39045 14.6448L8.4842 12.2385C8.75788 12.0256 9.14725 12.0499 9.39242 12.2951L11.2057 14.1083L13.4905 10.6811C13.618 10.4898 13.8327 10.3749 14.0625 10.3749H17.3673L20.2938 2.57104C20.4271 2.21552 20.8234 2.0354 21.1789 2.16872Z",
    fill: "#3D8ECC",
    stroke: "#3D8ECC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMovement);
export default __webpack_public_path__ + "static/media/product-movement.b804432c1c8e637e6c69ced081baddf1.svg";
export { ForwardRef as ReactComponent };